export default "__VITE_ASSET__Di4_dOPj__"